import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 15l6 -6l6 6","key":"svg-0"}]]

const IconChevronUp = createReactComponent('outline', 'chevron-up', 'ChevronUp', __iconNode);

export default IconChevronUp;